var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_1580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7273 3.0303H16.1212V1.21212C16.1212 0.890647 15.9935 0.582357 15.7662 0.35504C15.5389 0.127723 15.2306 0 14.9091 0C14.5876 0 14.2793 0.127723 14.052 0.35504C13.8247 0.582357 13.697 0.890647 13.697 1.21212V3.0303H7.63636V1.21212C7.63636 0.890647 7.50864 0.582357 7.28132 0.35504C7.05401 0.127723 6.74572 0 6.42424 0C6.10277 0 5.79448 0.127723 5.56716 0.35504C5.33984 0.582357 5.21212 0.890647 5.21212 1.21212V3.0303H4.60606C3.64164 3.0303 2.71669 3.41343 2.03474 4.09539C1.35279 4.77734 0.969696 5.70224 0.969696 6.66667V16.3636C0.969696 17.3281 1.35279 18.253 2.03474 18.9349C2.71669 19.6169 3.64164 20 4.60606 20H16.7273C17.6917 20 18.6166 19.6169 19.2986 18.9349C19.9805 18.253 20.3636 17.3281 20.3636 16.3636V6.66667C20.3636 5.70224 19.9805 4.77734 19.2986 4.09539C18.6166 3.41343 17.6917 3.0303 16.7273 3.0303ZM16.7273 17.5758H4.60606C4.28459 17.5758 3.97629 17.448 3.74898 17.2207C3.52166 16.9934 3.39394 16.6851 3.39394 16.3636V9.69697H17.9394V16.3636C17.9394 16.6851 17.8117 16.9934 17.5844 17.2207C17.357 17.448 17.0487 17.5758 16.7273 17.5758Z",
    fill: "#00357B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_1580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.3939,
    height: 20,
    fill: "white",
    transform: "translate(0.969696)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5e60dca02d666e941bdc23180494a768.svg";
export { ForwardRef as ReactComponent };